import BackCatalogUpsellModal from './BackCatalogUpsellModal';

export default BackCatalogUpsellModal;
